export interface Tag {
  href: string;
  label: string;
}

export function getTagLinks(tags: IFieldTag[]): Tag[] {
  return tags
    .map(tag => {
      const pageDelegatePath = tag.relationships?.field_page_delegate?.path?.alias ?? null;
      if (!pageDelegatePath) {
        return null;
      }

      return {
        href: pageDelegatePath,
        label: tag?.name ?? '',
      };
    })
    .filter(tag => tag !== null) as Tag[];
}
